<template>
  <div class="floorplan-preview">
    <!-- Close Button -->
    <div class="close-button">
      <button class="close-preview" @click="$emit('close-preview')">
        <svg width="42" height="42" viewBox="0 0 42 42">
          <circle cx="21" cy="21" r="20.5" />
          <path d="M29 13.3902L21.2 21M21.2 21L13 29M21.2 21L13 13M21.2 21L29 28.6098" />
        </svg>          
      </button>
    </div> 

    <!-- Image -->
    <div class="floorplan-image">
      <div class="image" :style="'background-image: url(' + image +');'"></div>
    </div>

    <!-- Floorplan Details -->
    <div class="floorplan-details">
      <h2>Plan {{ displayName }}</h2>
      <div class="plan-type" v-html="planType"></div>
      <div class="plan-size-info">
        <div class="interior-size">
          Interior SF: {{ interiorSize }}
        </div>
        <div class="exterior-size">
          Exterior SF: {{ exteriorSize }}
        </div>
        <div class="total-size">
          Total SF: {{ totalSize }}
        </div>
      </div>
      <a class="see-details" :href="planDetailsUrl">
        See Details
        <svg width="15" height="9" viewBox="0 0 15 9">
          <path d="M0 4.5H13M10 1L13.5 4.5L10 8" stroke="white"/>
        </svg>          
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'floorplan',
    'active-floor-group'
  ],
  data() {
    return {}
  },
  computed: {
    displayName() {
      return this.floorplan.display_name
    },
    planType() {
      return this.floorplan.plan_type.label
    },
    interiorSize() {
      return this.floorplan.interior_size
    },
    exteriorSize() {
      return this.floorplan.exterior_size
    },
    totalSize() {
      return this.floorplan.total_size
    },
    image() {
      return this.floorplan.image
    },
    planDetailsUrl() {
      let planDetailsUrl = this.floorplan.plan_url + '?floor_group=' + this.activeFloorGroup

      // // Find the highest view for the active floor group,
      // // and append it to the Plan Details URL
      // if ( this.floorGroupViews && this.floorGroupViews.length ) {
      //   let highestView = this.floorGroupViews.pop()
      //   planDetailsUrl = planDetailsUrl + '?view_level=' + highestView.slug
      // }

      return planDetailsUrl
    }
  }
}
</script>